// import _ from 'lodash'
// import { setWxCode, getWxCode, setFirstPage } from './session'
// import store from '../store/index'
import {
    getWxConfig
} from '../models/getWxConfigData'
import ua from '../utils/ua'
// import axios from 'axios'
// // import { WxBaseParams } from '../interfaces/wxConfigInterface'
// /**
//  * 添加第三方微信js
//  */
// import { Dialog } from 'vant';
const addWeixinSdk = () => {
    if (!ua.isWx) {
        return
    }
    const WxDom = document.createElement('script')
    WxDom.src = '//res.wx.qq.com/open/js/jweixin-1.6.0.js'
    const s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(WxDom, s)
}

/**
 * 微信环境 格式化URL
 *
 */
const formateUrl = (url) => {
    // 微信code返回&code=09002xdd
    // http://192.168.3.115:8080/#/activity_index 链接不带?,不带参数，需添加?
    // http://192.168.3.115:8080/?from=singlemessage#/activity_index 去掉?from
    let URL = url || location.href
    const hasQuery = URL.split('#')[1]
    hasQuery.indexOf('?') < 0 && (URL += '?')
    URL = URL.replace(/\?.{0,}#/, '#')
    // 支付路径绑定到hash之前
    URL = URL.replace(/#/, '?#')
    URL = encodeURIComponent(URL)
    return URL
}

function wxConfig () {
    var redirectUrl = '//v2.carisok.com/third/weixin.html' // 授权的URL,不需要encodeurl
    let thisHref = ''
    if (location.href.indexOf('?') >= 0) {
        thisHref = location.href
    } else {
        thisHref = location.href + '?'
    }
    var redirectBackUrl = encodeURIComponent(thisHref)
    var appid = 'wx64df375041b2c625'
    var wechatAuthUrl =
        redirectUrl + '?redirect_back=' + redirectBackUrl + '&appid=' + appid
    return wechatAuthUrl
}

// /**
//  * 跳转公众号授权页
//  * @param backUrl 需要跳转链接encodeURIComponent格式
//  * @param appId 公众号appid
//  */
// const redirectAuthor = (backUrl) => {
//     if (!backUrl) {
//         return
//     }
//     // 门店公众号appid 唯一标示
//     const appId = 'wx6996667435a97a7b'
//     // 快手公众号唯一标识
//     // const appId = 'wx066d014a25abfb88'
//     const redirectUrl = '//v2.carisok.com/third/weixin.html'
//     const authorUrl = `${redirectUrl}?redirect_back=${backUrl}&appid=${appId}`
//     location.href = authorUrl
// }
// /**
//  * 检测微信code是否存在
//  */
// const hasWxCode = (params) => {
//     // 首先查看session中是否有code
//     let code = ''
//     code = getWxCode()
//     if (!code) {
//         // url中code获取
//         code = params.code
//         !!code && setWxCode(code)
//     }
//     return !!code
// }
// /**
//  * 微信环境 格式化URL
//  *
//  */
// const formateUrl = (url)  => {
//     // 微信code返回&code=09002xdd
//     // http://192.168.3.115:8080/#/activity_index 链接不带?,不带参数，需添加?
//     // http://192.168.3.115:8080/?from=singlemessage#/activity_index 去掉?from
//     let URL = url || location.href
//     const hasQuery = URL.split('#')[1]
//     hasQuery.indexOf('?') < 0 && (URL += '?')
//     URL = URL.replace(/\?.{0,}#/, '#')
//     // 支付路径绑定到hash之前
//     URL = URL.replace(/#/, '?#')
//     URL = encodeURIComponent(URL)
//     return URL
// }
// /**
//  * 微信公众号授权：获取微信code
//  */
// const getweixinCode = () => {
//     const URL = formateUrl()
//     redirectAuthor(URL)
// }

// /**
//  * 记录firstPage，进入微信登录
//  * @param url当前url
//  */
// const recordUrl = (url, tips) => {
//     const goPath = url
//     goPath.query = _.omit(goPath.query, ['code'])
//     setFirstPage(JSON.stringify(goPath))
//     if (tips === 'b2b') {
//         goPath.path = '/officialb2b/login_wx'
//     } else if (tips === 'weishop') {
//         goPath.path = '/login_wx'
//     }
//     goPath.query = {}
//     return goPath
// }

// /**
//  * 获取微信配置信息
//  */
const configWeixin = async jsApiList => {
    if (!ua.isWx) {
        return
    }
    let apiList = [
        'checkJsApi',
        'chooseWXPay',
        'onMenuShareAppMessage',
        'onMenuShareTimeline',
        'showMenuItems',
        'hideMenuItems',
        'getLocation',
        // 'updateAppMessageShareData',
        // 'updateTimelineShareData'
        // 'onMenuShareQQ',
        // 'onMenuShareWeibo',
        // 'closeWindow',
        // 'translateVoice',
    ]
    apiList = jsApiList || apiList
    try {
        const data = await getWxConfig({
            url: encodeURIComponent(location.href.split('#')[0])
        })
        wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: apiList,
            openTagList: ['wx-open-launch-weapp']
        })
    } catch (error) {
        // console.log(error)
        // alert(error.toString())
        // alert('微信配置失败')
    }
}

/**
 * 微信分享
 */
const wxShare = shareData => {
    wx.ready(function () { // 需在用户可能点击分享按钮前就先调用
        // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
        // wx.updateAppMessageShareData({
        //     title: shareData.title, // 分享标题
        //     desc: shareData.desc, // 分享描述
        //     link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //     imgUrl: shareData.imgUrl, // 分享图标
        //     success: function () {
        //         // 设置成功
        //     }
        // })
        // // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
        // wx.updateTimelineShareData({
        //     title: shareData.title, // 分享标题
        //     link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //     imgUrl: shareData.imgUrl, // 分享图标
        //     success: function () {
        //         // 设置成功
        //     }
        // })
        wx.onMenuShareAppMessage({
            title: shareData.title, // 分享标题
            desc: shareData.desc, // 分享描述
            link: shareData.link + `&visitType=2`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            // imgUrl: shareData.imgUrl + `?x-oss-process=image/resize,w_80,h_80`, // 分享图标
            imgUrl: shareData.imgUrl, // 分享图标
            success: function () {
                // 设置成功
            }
        })
        /* flag = 1 使用描述作为标题 */
        const title = shareData.flag === 1 ? shareData.desc : shareData.title + (shareData.desc ? ' #' + shareData.desc : '')
        // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
        wx.onMenuShareTimeline({
            title: title, // 分享标题
            link: shareData.link + `&visitType=2`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            // imgUrl: shareData.imgUrl + `?x-oss-process=image/resize,w_80,h_80`, // 分享图标
            imgUrl: shareData.imgUrl, // 分享图标
            success: function () {
                // 设置成功
            }
        })
        wx.showMenuItems({
            menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline']
        })

        wx.hideMenuItems({
            menuList: ['menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook', 'menuItem:share:QZone'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        })
    })
}

const wxSharebyData = shareData => {
    wx.ready(function () { // 需在用户可能点击分享按钮前就先调用
        wx.onMenuShareAppMessage({
            title: shareData.appMesage.title, // 分享标题
            desc: shareData.appMesage.desc, // 分享描述
            link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            // imgUrl: shareData.appMesage.imgUrl + `?x-oss-process=image/resize,w_80,h_80`, // 分享图标
            imgUrl: shareData.appMesage.imgUrl, // 分享图标
            success: function () {
                // 设置成功
            }
        })
        // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
        wx.onMenuShareTimeline({
            title: shareData.timeline.title, // 分享标题
            link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            // imgUrl:  shareData.timeline.imgUrl + `?x-oss-process=image/resize,w_80,h_80`, // 分享图标
            imgUrl:  shareData.timeline.imgUrl, // 分享图标
            success: function () {
                // 设置成功
            }
        })
    })
}

function wxPaySdk (data) {
    // let _this = this
    return new Promise((resolve, reject) => {
        if (ua.isWx) {
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    'appId': data.appId, // 公众号名称，由商户传入
                    'timeStamp': data.timeStamp, // 时间戳，自1970年以来的秒数
                    'nonceStr': data.nonceStr, // 随机串
                    'package': data.package,
                    'signType': data.signType, // 微信签名方式：
                    'paySign': data.paySign // 微信签名
                },
                wxRes => {
                    if (wxRes.err_msg === 'get_brand_wcpay_request:ok') {
                        // 成功
                        // _this.Toast(_this.prompt)
                        // setTimeout(function () {
                        //     _this.$router.push('/myVehicle')
                        // }, 1000)
                        resolve()
                    } else if (wxRes.err_msg === 'get_brand_wcpay_request:cancel') {
                        // 取消
                        // this.Toast('取消支付')
                        reject(String('已取消支付'))
                    } else if (wxRes.err_msg === 'get_brand_wcpay_request:fail') {
                        // 失败
                        // this.Toast('支付失败')
                        reject(String('支付失败'))
                    }
                })
        }
    })
}

// hasWxCode,
// getweixinCode,
// recordUrl,
// configWeixin
// formateUrl
export {
    wxShare,
    wxSharebyData,
    addWeixinSdk,
    configWeixin,
    wxConfig,
    wxPaySdk,
    formateUrl
}
